import { useTranslation } from 'next-i18next';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { Meetingroom } from '../../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../../reduxToolkit/typedRedux';
import { createStudio } from '../../../../../../services/services';
import VyButton from '../../../../../common/VyButton';
import VyModal from '../../../../../common/VyModal';
import VyTextField from '../../../../../common/VyTextField';

interface CreateStudioModalProps {
  onClose: () => void;
  onSuccess: (studio: Meetingroom) => void;
  open: boolean;
}

interface FormProps {
  name: string;
}

export const CreateStudioModal = (props: CreateStudioModalProps) => {
  const { open, onClose, onSuccess } = props;

  const event = useSelector((state) => state.common.event);

  const {
    handleSubmit,
    register,
    formState: { isSubmitting },
  } = useForm<FormProps>();

  const { t } = useTranslation(['common', 'account']);
  async function submit(values: FormProps) {
    if (!event) return;

    try {
      const studio = await createStudio(event?._id, { name: values.name });
      toast.success(t('common:success'));
      onSuccess(studio);
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <VyModal open={open} onClose={() => onClose()}>
      {(onClose) => (
        <>
          <form onSubmit={handleSubmit(submit)} className="space-y-2">
            <VyTextField
              register={register('name', { required: true })}
              disabled={isSubmitting}
              label={t('account:studio.name').toString()}
              size="medium"
              fullWidth
            />
            <VyButton isSaveButton className="w-full" showLoadingIcon={isSubmitting} disabled={isSubmitting} type="submit">
              {t('common:save')}
            </VyButton>
          </form>
        </>
      )}
    </VyModal>
  );
};
